import { useSelector } from 'react-redux';
import { AccountOptions } from '@dev/ee-api/ee-api-models';
import { getGeneralInfo } from '@/store/account/actions';

export const useEnableContactHistory = (): boolean => {
    const { Options } = useSelector(getGeneralInfo);

    return Options?.includes(AccountOptions.EnableContactHistory);
};
